import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654f8522"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_ctx.withContainer)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        disabled: _ctx.disabled,
        class: _normalizeClass(_ctx.classes),
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, [
        _createVNode(_component_oxd_icon, {
          class: _normalizeClass({'--disabled': _ctx.disabled}),
          name: _ctx.name,
          type: _ctx.iconType
        }, null, 8, ["class", "name", "type"])
      ], 10, _hoisted_1))
    : (_openBlock(), _createBlock(_component_oxd_icon, {
        key: 1,
        name: _ctx.name,
        type: _ctx.iconType,
        class: _normalizeClass({'oxd-icon-button__icon': true, '--disabled': _ctx.disabled}),
        onClick: _ctx.onClick
      }, null, 8, ["name", "type", "class", "onClick"]))
}